import btcLogo from "./assets/btc.svg";
import ethLogo from "./assets/eth.svg";
import solLogo from "./assets/sol.svg";
import bnbLogo from "./assets/bnb.svg";
import tronLogo from "./assets/trx.svg";
import baseLogo from "./assets/base.svg";
import dogeLogo from "./assets/doge.svg";
import tonLogo from "./assets/ton.svg";

export const CHAINS = [
  {
    id: "btc",
    chainName: "BITCOIN",
    ticker: "BTC",
    color: "#F7931A",
    address: "3HGQ2snQDqEja42gqBL1qWcirBB4UVQL6Q",
    logo: btcLogo,
  },
  {
    id: "eth",
    chainName: "ETHEREUM",
    ticker: "ETH",
    color: "#627EEA",
    address: "0xB2fbee52FCab201002f06343a88012fCbbD5aA5d",
    logo: ethLogo,
  },
  {
    id: "sol",
    chainName: "SOLANA",
    ticker: "SOL",
    color: "#14F195",
    address: "3cyx3hRogW1VfzNPQ7yDLqbUtTEagDyG4sWYVTFJuktD",
    logo: solLogo,
  },
  {
    id: "bnb",
    chainName: "BSC",
    ticker: "BNB",
    color: "#F3BA2F",
    address: "0x2caA20B5022f4f1d82387f0880a9940eCF9Ed2cA",
    logo: bnbLogo,
  },
  {
    id: "tron",
    chainName: "TRON",
    ticker: "TRX",
    color: "#F3000F",
    address: "TPnBVq5zVc3YtiiiLbJwSRUjqQvU92vjFG",
    logo: tronLogo,
  },
  {
    id: "base",
    chainName: "BASE",
    ticker: "ETH",
    color: "#0052FF",
    address: "0xB2fbee52FCab201002f06343a88012fCbbD5aA5d",
    logo: baseLogo,
  },
  {
    id: "doge",
    chainName: "DOGECOIN",
    ticker: "DOGE",
    color: "#dfc66d",
    address: "DTYc4KuESi8KuAzxAdu1XvGCCkHMiPvC8s",
    logo: dogeLogo,
  },
  {
    id: "ton",
    chainName: "TON",
    ticker: "TON",
    color: "#0098ea",
    address: "UQBIOKcjs2KpTLVhmTQtGwgdckDQ-57UQJGtE8P5y0A6T4Ka",
    logo: tonLogo,
  },
];
